export type RuntimeMode = 'desktop' | 'wecom' | 'mobile-public'

export interface RuntimeConfig {
  mode: RuntimeMode
  contentUrl: string
  label: string
  requiresSession: boolean
}

export const runtimeConfig: RuntimeConfig = {
  mode: import.meta.env.VITE_RUNTIME_MODE,
  contentUrl: import.meta.env.VITE_CONTENT_URL,
  label:
    import.meta.env.VITE_RUNTIME_MODE === 'desktop'
      ? 'Windows 离线端'
      : import.meta.env.VITE_RUNTIME_MODE === 'mobile-public'
        ? '手机 H5 客户版'
        : '企业微信内部端',
  requiresSession: import.meta.env.VITE_RUNTIME_MODE === 'wecom'
}
